import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { motion } from 'framer-motion';
import { TypeAnimation } from 'react-type-animation';
import typygif from "../../public/images/banerarowgif.gif";
import abouttextbg1 from "../../public/images/abouttextbg1.png";
import aboutredcc from "../../public/images/red-color.png";
import aboutunnerimg from "../../public/images/aboutinnerimg.png";
import aboutbanergif from "../../public/images/aboutbaner.gif";

const Aboutusbaner = () => {
  return (
    <>
        <div className='aboutbglinergradient flex justify-center items-center'>
         <div className='lg:ml-[82px] lg:mx-0 mx-5'>
           <div className='grid grid-cols-1 lg:grid-cols-2'>
              <div className='mt-[150px] lg:w-[91%] w-full'>
              <div className='text-xl font-bold text-[#FF5349] -ml-[4px]'> #WeDriveEasyCampus</div><br /><br />
               <motion.p
                  initial={{ y: 100, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  transition={{
                    delay: 0.2,
                    y: {
                      type: "spring",
                      stiffness: 60
                    },
                    opacity: { duration: 1 },
                    ease: "easeIn", duration: 1
                  }}
                  className='lg:text-[34px] text-[28px] text-black border-[5px] border-black px-4 py-4  mt-10  text-center font-semibold'>TEAMING UP TO SHAPE THE FUTURE</motion.p>
                <motion.p
                  initial={{ y: 100, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  transition={{
                    delay: 0.2,
                    y: {
                      type: "spring",
                      stiffness: 60
                    },
                    opacity: { duration: 1 },
                    ease: "easeIn", duration: 1
                  }}
                  className='lg:text-[40px] text-[20px] mt-2 font-extrabold mb-5 text-center text-black'>ACCELERATE TRANSFORMATION</motion.p>
                  <div className='flex text-center items-center mt-14 mb-3 '>
                    <div className='bg-black h-3 w-[25%] '></div>
                    <div className='w-[50%] text-black text-xl'>BUILD LASTING CONNECTIONS</div>
                    <div className='bg-black h-3 w-[25%]'></div>
                  </div>
                <motion.p
                  initial={{ y: 100, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  transition={{
                    delay: 0.2,
                    y: {
                      type: "spring",
                      stiffness: 60
                    },
                    opacity: { duration: 1 },
                    ease: "easeIn", duration: 1
                  }}
                  className='lg:text-[19px] text-xl text-black justify-normal text-center'>By harnessing the capabilities of individuals and technology, we enhance the impact of work to drive meaningful global change
                </motion.p>
                <div className='mt-12 flex justify-center'>
                  <motion.button
                    initial={{ y: -50, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{
                      delay: 0.4,
                      y: {
                        type: "spring",
                        stiffness: 60
                      },
                      opacity: { duration: 1 },
                      ease: "easeIn", duration: 1
                    }}
                    disabled
                    className='py-1 text-xl aboutbanerbtn flex items-center text-black  w-[47%] text-center'>WATCH <motion.span disabled className='mx-3'><Link id="play-video" className="video-play-button" href="#" data-toggle="modal" data-target="#savoybeachhotel">
                      <span></span>
                    </Link></motion.span> NOW</motion.button>
                </div>
              </div>
              <div>
               <div className='about_baner_01'>
                <Image src={aboutredcc} alt='online assessment' width={425} className='rotate-[-2deg]' />
              <div className='aboutbaneranimated_text'>
                <h1
                  initial={{ y: 100, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  transition={{
                    from: 90, duration: 2,
                    delay: 0.2,
                    y: { type: 'spring', stiffness: 60 },
                    opacity: { duration: 1 },
                    ease: 'easeIn',
                    duration: 1,
                  }}
                  className='save_tec'>
                  <span className='saveaboutypeanimation  '>
                    Save{' '} <br />
                  </span>
                  <TypeAnimation
                    sequence={['Time', 3000, 'Energy', 3000, 'Cost', 3000]}
                    wrapper='span'
                    speed={20}
                    repeat={Infinity}
                    cursor={0}
                    className='abouttypeanimation'
                  />
                </h1>
                <motion.div
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5 }}
                  className='aboutbaner_02 '>
                  <div className='relative'>
                    <Image src={abouttextbg1} alt='off campus placements' className='w-24' />
                    <div className='try_our_text'>Try Our</div>
                  </div>
                  <p className="unified_platform_text">Unified Platform</p>
                  <Image src={typygif} alt='mock interviews' className='mb-2 lg:ml-12 hidden lg:block' />
                  <Image src={aboutbanergif} alt='virtual hiring' className='block lg:hidden -ml-5'/>
                </motion.div>
              </div>
              </div>
              <div className='lg:-mt-[210px] -mt-9'>
              <Image src={aboutunnerimg} alt='virtual campus drive'/>
              </div>
              </div>
              </div>
           </div>
          </div>
    </>
  )
}

export default Aboutusbaner